export interface DeviceSummaryFormData {
	date: DeviceSummaryRange | null;
	dateRange: Date[] | null;
	email: string | null;
	notes: string | null;
	healthSummaryReportSections: string[];
}

export interface HealthSummaryReportSections {
	showCoverPage: boolean;
	showEngagementSummary: boolean;
	showHedisMeasures: boolean;
	showSmartGoals: boolean;
	showMedicalReadings: boolean;
}

export enum DeviceSummaryRange {
	DAYS7 = "DAYS7",
	DAYS30 = "DAYS30",
	DAYS90 = "DAYS90",
	CUSTOM = "CUSTOM",
}
